import React from 'react';
import './TitleAndDescription.module.scss';

type Props = {
  attributes: any;
  inPopup?: boolean;
};

export default function TitleAndDescription({ attributes, inPopup }: Props) {
  return (
    <div styleName="title-and-description">
      {attributes?.title && <h2>{attributes?.title}</h2>}
      {inPopup && !attributes.title ? (
        <h2>{attributes?.description}</h2>
      ) : (
        <p>{attributes?.description}</p>
      )}
    </div>
  );
}
